/* Cart – shared helpers */
export const $  = (s, r = document) => r.querySelector(s);
export const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

export function debounce(fn, ms = 250) {
  let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
}

export function wooRefreshFragments() {
  if (window.jQuery) window.jQuery(document.body).trigger('wc_fragment_refresh');
}
export function wooAddedToCart() {
  if (window.jQuery) window.jQuery(document.body).trigger('added_to_cart');
}

/** Swap cart DOM with returned HTML (items + totals) */
export function patchCartFromHTML(htmlText) {
  try {
    const dom = new DOMParser().parseFromString(htmlText, 'text/html');

    // ITEMS (your wrapper OR Woo default form)
    const newItems = dom.querySelector('.wk-cart-items') || dom.querySelector('.woocommerce-cart-form');
    const curItems = document.querySelector('.wk-cart-items') || document.querySelector('.woocommerce-cart-form');
    if (newItems && curItems) curItems.replaceWith(newItems);

    // TOTALS / SUMMARY – support your `.wk-summary` first
    const totalSelectors = [
      '.wk-summary',           // ← your DOM
      '.wk-cart-summary',
      '.wk-cart-totals',
      '.cart_totals',
      '.cart-collaterals',
    ];
    let newSum = null, curSum = null;
    for (const sel of totalSelectors) {
      newSum = newSum || dom.querySelector(sel);
      curSum = curSum || document.querySelector(sel);
    }
    if (newSum && curSum) {
      curSum.replaceWith(newSum);
    } else {
      // Fallback: update just the number
      const newAmt = dom.querySelector('.wk-cart-amount bdi, .order-total .amount bdi, .order-total .amount');
      const curAmt = document.querySelector('.wk-cart-amount bdi, .order-total .amount bdi, .order-total .amount');
      if (newAmt && curAmt) curAmt.innerHTML = newAmt.innerHTML;
    }
  } catch (err) {
    console.error('[Cart] patchCartFromHTML failed', err);
  }
}

/** Optional: single place to let Woo know totals changed */
export function triggerCartUpdated() {
  if (!window.jQuery) return;
  const $b = window.jQuery(document.body);
  $b.trigger('updated_wc_div');
  $b.trigger('cart_page_refreshed');
  $b.trigger('updated_cart_totals'); // some plugins/themes listen to this
}

/** POST a form (supports optional AbortController signal) */
export async function postForm(url, formData, signal) {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    signal,
  });
  return res.text();
}
